import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'viewCharges',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      total: 0
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('view_charges_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        console.log('dataObj', this.dataObj);
        this.getTotal();
      });
    },
    getTotal() {
      for (var i = 0; i < this.dataObj.length; i++) {
        this.total = this.total + Number(this.dataObj[i].totalCost.toFixed(3));
      }

      this.total = this.total.toFixed(3);
    }
  },
}
